const prohibitedWords = [
    "sex",
    "vodka",
    "tequila",
    "beer",
    "drunk",
    "violence",
    "drugs",
    "adult",
    "alchohol",
    "liquor"
    // Add more words as needed
];

export default prohibitedWords;
